<template>
  <div class="offers">
    <div class="filter-wrapper">
     <div class="inputs-wrapper">
        <h3>Filter po</h3>
        <md-radio v-model="topFilter" :value="'performance'">Izvedbi</md-radio>
        <md-radio v-model="topFilter" :value="'partner'">Partneru</md-radio>
        <md-radio v-model="topFilter" :value="'id'">Broju transakcije</md-radio>
        <md-radio v-model="topFilter" :value="'date'">Datumu isteka ponude</md-radio>
        <md-radio v-model="topFilter" :value="'payment_date'">Datumu naplate ponude</md-radio>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'id'">
        <h3>ID</h3>
        <md-field>
          <label>ID</label>
          <md-input v-model="transactionID"/>
        </md-field>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'date'">
        <h3>Datum</h3>
        <div class="date-wrapper">
          <md-datepicker v-model="start_date" md-immediately>
            <label>Od</label>
          </md-datepicker>
          <md-datepicker v-model="end_date" md-immediately>
            <label>Do</label>
          </md-datepicker>
        </div>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'payment_date'">
        <h3>Datum</h3>
        <div class="date-wrapper">
          <md-datepicker v-model="start_date" md-immediately>
            <label>Od</label>
          </md-datepicker>
          <md-datepicker v-model="end_date" md-immediately>
            <label>Do</label>
          </md-datepicker>
        </div>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'performance'">
        <h3>Izvedba</h3>
        <Autocomplete v-model="performanceID" :additionalField="'performance_date'" :stateObject="'performancesSimple'" :searchBy="'play_title'" :returnField="'id'" :label="'Odaberi izvedbu'"/>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'partner'">
        <h3>Partner</h3>
        <div>
          <Autocomplete v-model="partnerID" :stateObject="'partners'" :returnField="'id'" :searchBy="'title'" :label="'Odaberi partnera'"/>
        </div>
      </div>
      <div class="inputs-wrapper with-button">
        <md-button class="md-raised md-dense md-primary" v-on:click="filterTransactions()">Prikaži</md-button>
        <md-button class="md-raised md-dense md-accent" :disabled="!searched" v-on:click="clear()">Poništi</md-button>
      </div>
    </div>
    <md-tabs md-alignment="centered">
      <md-tab md-label="Neautorizirano" v-on:click="filter = ['partner_checkout']"/>
      <md-tab md-label="Prodano" v-on:click="filter = ['partner_sold']"/>
      <md-tab md-label="Isteklo" v-on:click="filter = ['expired']"/>
      <md-tab md-label="Sve" v-on:click="filter = ['all']"/>
    </md-tabs>
    <div v-if="filteredTransactions.length > 0 && $store.state.pageLoaded">
      <md-table v-model="filteredTransactions" md-sort="id">
        <md-table-toolbar>
          <div class="md-toolbar-section-start">
            <h1 class="md-title">Ponude</h1>
          </div>
        </md-table-toolbar>

        <md-table-row>
          <md-table-head>ID</md-table-head>
          <md-table-head>Predstava</md-table-head>
          <md-table-head>Broj ponude</md-table-head>
          <md-table-head>Vrijedi do</md-table-head>
          <md-table-head>Partner</md-table-head>
          <md-table-head>Status</md-table-head>
          <md-table-head class="t-align-center">Akcije</md-table-head>
        </md-table-row>

        <md-table-row md-selectable="single" md-auto-select slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="ID" md-sort-by="id" class="md-numeric">{{ item.id }}</md-table-cell>
          <md-table-cell md-label="Predstava" md-sort-by="data.play_title"><b>{{ item.data.play_title }}</b> - {{ getPlayDate(item.data.performance_time).date }} - {{ getPlayDate(item.data.performance_time).time }}</md-table-cell>
          <md-table-cell md-label="Broj ponude" md-sort-by="offer">{{ item.offer }}</md-table-cell>
          <md-table-cell md-label="Napomena" md-sort-by="data.note">{{ item.data.note }}</md-table-cell>
          <md-table-cell md-label="Vrijedi do" md-sort-by="expiry_date">{{ getPlayDate(item.expiry_date).date }}</md-table-cell>
          <md-table-cell md-label="Partner" md-sort-by="data.partner.title">{{ item.data.partner.title }}</md-table-cell>
          <md-table-cell md-label="Status" md-sort-by="status">{{ getStatus(item.status, item.data.is_cancelled) }}</md-table-cell>
          <md-table-cell md-label="Akcije" class="actions-cell">
            <md-button class="md-raised md-dense md-accent" :disabled="['aborted', 'cancelled'].includes(item.status) || item.disabled" title="Storno" v-on:click="stornoDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(item)); clickedItem = item">
              Storno
            </md-button>
            <md-button class="md-raised md-dense md-primary" title="Detalji" v-on:click="showTransaction(item)">
              Detalji
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
    <h3 v-if="filteredTransactions.length == 0" class="error">Nažalost nema ništa za prikaz</h3>
    <md-dialog-confirm :md-active.sync="stornoDialog"
                md-title="Storno transakcije"
                md-content="Jeste li sigurni?"
                md-confirm-text="Potvrdi"
                md-cancel-text="Zatvori"
                v-on:md-confirm="stornoSelected"
                >
    </md-dialog-confirm>
    <TransactionDetails :fromPage="true" v-if="detailsVisible" @close="detailsVisible = false" class="details-page"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Offers',
  data(){
    return {
      topFilter: 'id',
      filter: [],
      clickedItem: {},
      performanceID: 0,
      partnerID: 0,
      detailsVisible: false,
      transactionID: '',
      end_date: new Date(),
      start_date: new Date(),
      searched: false,
      filteredTransactions: [],
      stornoDialog: false,
    }
  },

  computed:{
    ...mapGetters([
      'getStatus',
      'getFilteredTransactions',
      'isPageLoaded',
    ])
  },

  methods: {
    stornoSelected(){
      this.clickedItem.disabled = true;
      this.$store.state.isTheatre = true;
      this.$store.state.currentTransaction = JSON.parse(JSON.stringify(this.$store.state.selectedObject));
      this.$store.dispatch('cancelTransaction', {status: 'aborted'})
    },

    zeroed(data){
      if(parseInt(data) < 10) return `0${data}`
      return data;
    },

    getPlayDate(data){
      let date = new Date(data);
      return{
        date: `${this.zeroed(date.getDate())}.${this.zeroed(date.getMonth()+1)}.${this.zeroed(date.getFullYear())}.`,
        time: `${this.zeroed(date.getHours())}:${this.zeroed(date.getMinutes())}`,
      }
    },

    showTransaction(item){
      this.$store.state.currentTransaction = JSON.parse(JSON.stringify(item));
      this.detailsVisible = true;
    },

    async filterTransactions(){
      this.$store.state.pageLoaded = false;
      this.searched = true;
      let filter = {}
      if(this.topFilter == 'id') filter['id'] = this.transactionID;
      if(this.topFilter == 'partner') filter['partner'] = this.partnerID;
      if(this.topFilter == 'performance') filter['performance'] = this.performanceID;
      if(this.topFilter == 'date') {
        if(this.end_date < this.start_date) filter['end_date'] = this.start_date.toLocaleDateString('hr-HR');
        else filter['end_date'] = this.end_date.toLocaleDateString('hr-HR');
        filter['start_date'] = this.start_date.toLocaleDateString('hr-HR');
      }
      if(this.topFilter == 'payment_date') {
        if(this.end_date < this.start_date) filter['payment_end_date'] = this.start_date.toLocaleDateString('hr-HR');
        else filter['payment_end_date'] = this.end_date.toLocaleDateString('hr-HR');
        filter['payment_start_date'] = this.start_date.toLocaleDateString('hr-HR');
      }
      await this.$store.dispatch('getOffers', filter)
      this.filteredTransactions = this.getFilteredTransactions({searchKey: this.filter, list: this.$store.state.receivedData.offers.list});
      this.$store.state.pageLoaded = true;
    },

    async clear(){
      this.$store.state.pageLoaded = false;
      await this.$store.dispatch('getOffers');
      this.searched = false;
      this.$store.state.pageLoaded = true;
      this.filteredTransactions = this.getFilteredTransactions({searchKey: this.filter, list: this.$store.state.receivedData.offers.list});
    }
  },

  watch:{
    filter(val){
      this.filteredTransactions = this.getFilteredTransactions({searchKey: val, list: this.$store.state.receivedData.offers.list});
    },

    isPageLoaded(value){
      if(value && this.partnerID == 0){
        this.filter = ['partner_checkout'];
        this.partnerID = this.$store.state.receivedData.partners.list > 0 ? this.$store.state.receivedData.partners.list[0].id : '';
        this.performanceID = this.$store.state.receivedData.performancesSimple.list > 0 ? this.$store.state.receivedData.performancesSimple.list[0].id: '';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.offers{
  .md-table{
    .md-table-cell{
      &.actions-cell{
        width: 254px;
        max-width: 254px;
      }
    }
  }
}

.error{
  font-size: 22px;
  margin: 100px 0 50px 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Tickets/Offers.vue